import React, { useEffect, useState } from "react";
import "./Footer.css";
import axios from "axios";
import config from "../../confiq/confiq";

function Footer() {
  const [footerData, setFooterData] = useState(null);
  const currentYear = new Date().getFullYear(); 

  useEffect(() => {
    axios
      .get(`${config.apiUrl}api/home/footer`, {
        headers: config.headers,
      })
      .then((response) => {
        setFooterData(response?.data?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <div className="section-footer">
      <div className="padding-global">
        <div className="container-large">
          <div className="padding-section-medium footer-space">
            <div className="footer-wrapper">
              <div className="footer-logo-newsletter-wrapper">
                <a
                  href="/"
                  aria-current="page"
                  className="footer-logo-link footer-bg w-inline-block w--current"
                >
                  <img
                    src={footerData?.logo?.data?.attributes?.url}
                    loading="lazy"
                    width={188}
                    alt={footerData?.logo?.data?.attributes?.alternativeText}
                    className="image-12"
                  />
                </a>

                {footerData?.links?.length > 0 && (
                  <div className="social-icons">
                    {footerData.socialMediaLink
                      .filter((link) => link.category === "Social-Link")
                      .map((link) => (
                        <a
                          key={link.id}
                          href={link.url}
                          target={link.target}
                          rel={link.target === "_blank" ? "noopener noreferrer" : ""}
                          className="social-icon-link"
                        >
                          <img src={link.icon} alt={link.text} className="social-icon-img" />
                        </a>
                      ))}
                  </div>
                )}
              </div>

              <div className="div-block-89">
                <div className="footer-links">
                  {footerData?.links?.length > 0 &&
                    [...new Set(footerData.links.map((link) => link.category))].map((category) => {
                      const categoryLinks = footerData.links.filter((link) => link.category === category);
                      return (
                        <div key={category} className="footer-col">
                          <div className="footer-col-title">{category}</div>
                          <ul role="list" className="footer-list-wrapper">
                            {categoryLinks.map((link) => (
                              <li key={link.id} className="footer-list-item">
                                {link.url ? (
                                  <a
                                    href={link.url}
                                    className="footer-link"
                                    target={link.target}
                                    rel={link.target === "_blank" ? "noopener noreferrer" : ""}
                                  >
                                    {link.icon && <img src={link.icon} alt="" className="footer-link-icon" />}
                                    {link.text}
                                  </a>
                                ) : (
                                  <span className="footer-link">
                                    {link.icon && <img src={link.icon} alt="" className="footer-link-icon" />}
                                    {link.text}
                                  </span>
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="footer-address-wrapper padding-medium">
              <div className="address-text text-color-grey">{footerData?.address} {currentYear}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
